import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

/*Services */
import { CachedDataService } from '@services/data/cached-data.service';
import { BaseHttpService } from '@services/http/base-http.service';
import { AuthService } from '@services/http/auth.service';

/*Models*/
import { ObjectSerachResponse } from '@models/responses/object-search-response';
import { ObservableObject } from '@models/observable-object';

/*environments*/
import { environment } from '@environments';

/*config*/
import { CONFIG } from '../../../config';


@Injectable()

export class ObservableObjectsService extends BaseHttpService {

  constructor(protected httpClient: HttpClient,
    protected cachedDataService: CachedDataService,
    protected loginService: AuthService,
    protected router: Router) {
    super(httpClient, cachedDataService, router, loginService);
  }

  getObjectById(id: string): Observable<ObservableObject> {
    const uri = environment.apiUri + `object/${id}?extended=true`;
    return super.send('GET', uri);
  }

  getAll(): Observable<ObservableObject[]> {
    const uri = environment.apiUri + 'object?extended=true';
    return super.send('GET', uri);
  }


  getAllByUser(userId): Observable<ObjectSerachResponse> {
    const uri = environment.apiUri + `object/search?extended=true&userId=${userId}`;
    return super.send('GET', uri);
  }

  getObjectType(extra: string) {
    if (extra) {
      for (const type of CONFIG.objectTypes) {
        if (extra.indexOf(type) >= 0) {
          return type.toLowerCase();
        }
      }
    } else {
      return 'default';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/http/observable-objects.service.ts